export default __webpack_public_path__ + "static/logo-defd2bce48e145b11d296456413c350f.jpg";